// take in an object and turn any values into json.stringify
export default function cleanLeaveZero(obj) {
   for(const k in obj) {
       if(obj[k] == null || obj[k] == undefined) {
           delete obj[k]
       }
   }

   return obj
}